export default __webpack_public_path__ + "static/Saurabh-c6d26b735378af43ea18868a61d49aee.jpeg";